import React, { Component } from 'react';

import Input, { InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import { CircularProgress } from 'material-ui/Progress';
import IconButton from 'material-ui/IconButton';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';

import CameraIcon from '@material-ui/icons/CameraAlt';
import ChatIcon from '@material-ui/icons/Chat';
import CloseIcon from '@material-ui/icons/Close';

import Dropzone from 'react-dropzone';

import * as FeedState from '../../../state/reducer/feed/feed';
import CONF from '../../../api/config';
import SecondaryButton from '../../common/component/SecondaryButton';

import Console from '../../../lib/debug';

export default class CalendarSummaryFeedInput extends Component {
    state = {
        dirty: false,
        imageLoading: false,
        newReply: {
            type: 0,
            access_level: 0,
            content: '',
            anchored: 0,
            mentions: '',
            parent_feed_item_id: null
        }
    };

    async onDrop(file) {
        let fd = new FormData();
        fd.append('file', file[0]);
        this.setState({
            ...this.state,
            imageLoading: true
        });
        await FeedState.uploadPhoto(fd);
        this.setState({
            imageLoading: false
        });
    }

    handleChangeInput(feedCard, newVal) {
        let newReply = {};

        if (feedCard) {
            newReply = {
                type: 0,
                access_level: 0,
                content: newVal.target.value,
                photo_url: this.props.imageUploaded
                    ? this.props.imageUploaded.fullPath
                    : '',
                anchored: 0,
                mentions: '',
                parent_feed_item_id: feedCard.feed_item_id
            };
        }

        this.setState({
            ...this.state,
            newReply: newReply,
            dirty: newVal.target.value !== '' ? true : false
        });
    }

    postComment(newReply, currentFeedCardId) {
        let { feedData } = this.props;
        let imageUploaded = feedData.imageUploaded;
        let feedCard = feedData.feedCard;

        if (imageUploaded) {
            newReply.photo_url = imageUploaded.fullPath;
        }

        FeedState.createFeedItem(currentFeedCardId, newReply, feedCard);
        this.resetState();
    }

    removePhoto() {
        FeedState.clearPhotoPreview();
        this.setState({
            ...this.state,
            file: null,
            newReply: {
                ...this.state.newReply,
                photo_url: ''
            }
        });
    }

    resetState() {
        this.setState({
            dirty: false,
            imageLoading: false,
            newReply: {
                type: 0,
                access_level: 0,
                content: '',
                anchored: 0,
                mentions: '',
                parent_feed_item_id: null
            }
        });
    }

    render() {
        Console.render('CalendarSummaryFeed');

        let { feedData } = this.props;
        let feedCard = feedData.feedCard;
        let previewImage = null;

        if (feedData.imageUploaded) {
            previewImage = (
                <div className="preview-container-class">
                    <Paper elevation={4}>
                        <div className="preview-image">
                            <Button
                                variant="fab"
                                className="close"
                                onClick={this.removePhoto.bind(this)}
                            >
                                <CloseIcon />
                            </Button>
                            <img
                                alt="preview-thumb"
                                src={feedData.imageUploaded.thumbFullPath}
                            />
                        </div>
                    </Paper>
                </div>
            );
        }

        const postButton = (
            <SecondaryButton
                onClick={this.postComment.bind(
                    this,
                    this.state.newReply,
                    feedCard.feed_id
                )}
                disabled={
                    this.state.newReply.content.length === 0 ||
                    this.state.imageLoading
                }
            >
                Post
            </SecondaryButton>
        );

        return (
            <div className="feed-footer">
                <div className="border-bottom-line" />
                <div className="reply-section">
                    <IconButton>
                        <Dropzone
                            onDrop={this.onDrop.bind(this)}
                            multiple={false}
                            className="drop-zone-area"
                        >
                            <CameraIcon />
                        </Dropzone>
                    </IconButton>
                    <div className="reply-entry">
                        {previewImage}
                        <FormControl>
                            <Input
                                type="text"
                                fullWidth={true}
                                placeholder="Add comment here..."
                                value={this.state.newReply.content}
                                multiline={true}
                                onChange={this.handleChangeInput.bind(
                                    this,
                                    feedCard
                                )}
                                endAdornment={
                                    <InputAdornment position="end">
                                        {postButton}
                                    </InputAdornment>
                                }
                                disableUnderline={true}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
        );
    }
}
